import React from "react"
import { Download } from "lucide-react"
import StatusNoticeItem from "./StatusNoticeItem.jsx"

export const UPDATE_AVAILABLE_LABEL = "Update Available"
export const UPDATE_AVAILABLE_BG_COLOR = "#ffc107"
export const UPDATE_AVAILABLE_TEXT_COLOR = "#212529"

/**
 * Shared "Update Available" notice for sidebar footer and mobile top bar.
 * Apps supply visibility and the update activation handler.
 *
 * @param {{
 *   updateAvailable: boolean,
 *   onUpdate: (() => void) | (() => Promise<void>),
 *   placement?: "sidebar" | "mobileTopBar",
 * }} props
 */
export default function UpdateAvailableNotice({
  updateAvailable,
  onUpdate,
  placement = "sidebar",
}) {
  if (!updateAvailable) {
    return null
  }

  return (
    <StatusNoticeItem
      placement={placement}
      label={UPDATE_AVAILABLE_LABEL}
      Icon={Download}
      bgColor={UPDATE_AVAILABLE_BG_COLOR}
      textColor={UPDATE_AVAILABLE_TEXT_COLOR}
      onClick={onUpdate}
    />
  )
}
